import { render, staticRenderFns } from "./PaymentAppManageSetting.vue?vue&type=template&id=72f5d2d4&"
import script from "./PaymentAppManageSetting.vue?vue&type=script&lang=js&"
export * from "./PaymentAppManageSetting.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAppManageSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports